import { rem } from "@mantine/core";
import styled from "styled-components";

import {
  absoluteCenter,
  bp,
  circle,
  clipBorderRadius,
  flexCenter,
  flexSpBetween,
  media,
  pseudo,
  size,
} from "@styles/Utilities.styled";


export const StyledVideoCall = styled.div`
  position: absolute;
  width: ${rem(200)};
  height: ${rem(150)};
  top: 0.5rem;
  right: 0.5rem;
  z-index: 9999;
  /* outline: 1px solid red; */

  &.is-maximized {
    --videocall-navbar-height: ${rem(48)};

    position: fixed;
    top: var(--videocall-navbar-height);
    left: 0;
    ${size("100%", "calc(100vh - var(--videocall-navbar-height))")};
    ${size("100%", "calc(100dvh - var(--videocall-navbar-height))")};
    z-index: 9999;

    .navbar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      ${flexSpBetween}
      background-color: var(--clr-white);
      outline: 1px solid red;
      padding-left: 1rem;
      padding-right: 0.35rem;

      .left-section {
      }

      .middle-section {
      }

      .right-section {
        width: 8ch;
      }
    }

    .maximize-btn {
      top: 1rem;
      right: 1rem;
    }

    .user.local {
      position: absolute;
      inset: unset;
      bottom: 1.5rem;
      right: 1.5rem;
      width: ${rem(200)};
      height: ${rem(150)};
      z-index: 3;

      ${media(bp.large1)} {
        width: ${rem(288)};
        height: ${rem(216)};
      }

      &.no-remote-user {
        ${size("auto")}
        inset: 0;

        .microphone-wrapper {
          top: 1rem;
          right: 3.25rem;
        }
      }

      .microphone-wrapper {
        top: 0.5rem;
        right: 0.5rem;
        left: unset;
        z-index: 3;
      }

      .username-wrapper {
        bottom: 0.5rem;
        left: 0.75rem;
      }
    }

    .user.remote {
      & > div {
        div:first-child {
          & > div {
            left: 50%;
            transform: translateX(-50%);
            width: min(100%, ${rem(450)}) !important;
            height: 100% !important;
          }
        }
      }

      .username-wrapper {
        bottom: unset;
        top: 1.5rem;
      }

      .microphone-wrapper {
        top: 1rem;
        right: 3.25rem;
        left: unset;
      }
    }

    .avatar {
      ${size(rem(80))}
      span {
        font-size: ${rem(22)};
      }
    }

    .username-wrapper {
      display: block;
      bottom: 0.5rem;
      left: 0.5rem;
    }
  }

  .maximize-btn,
  .drag-btn {
    position: absolute;
    z-index: 99;
    top: 0.5rem;
    background-color: rgba(0, 0, 0, 0.35);
  }

  .maximize-btn {
    right: 0.5rem;
  }

  .drag-btn {
    top: 0.5rem;
    right: 2.5rem;
    cursor: move;
  }

  .user-list {
    ${size("100%")}
  }

  .user {
    position: absolute;
    inset: 0;
    ${size("100%")}
    border-radius: var(--border-radius-3);
    overflow: hidden;

    &::before {
      ${pseudo}
      ${size("100%")}
      border-radius: inherit;
      z-index: 2;
      transition: border-color 1s;
      border: 3px solid transparent;
    }

    &.voice-detected {
      &::before {
        transition: border-color 0s;
        border-color: var(--mantine-color-blue-2);
      }
    }

    &.local {
      z-index: 1;

      & > div:first-child {
        background: rgb(52, 52, 52) !important;
      }
    }

    &.remote {
      z-index: 2;

      & > div {
        background: rgb(54, 57, 63) !important;
      }
    }

    .avatar {
      ${absoluteCenter}
      z-index: 3;
    }
  }

  .username-wrapper {
    display: none;
    position: absolute;
    left: 0.5rem;
    bottom: 0.5rem;
    backdrop-filter: blur(5px);
    /* background-color: rgba(0, 0, 0, 0.35); */
    /* ${clipBorderRadius("var(--border-radius-2)")} */
  }

  .username {
    color: var(--clr-white);
    font-size: ${rem(14)};
    z-index: 2;
  }

  .network-mic-wrapper {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;

    & > div {
      ${flexCenter}
      ${circle(rem(30))}
      background-color: rgb(0, 0, 0, 0.35);
      z-index: 2;
    }
  }

  .microphone-wrapper {
    ${flexCenter}
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    ${circle(rem(30))}
    background-color: rgb(0, 0, 0, 0.35);
    z-index: 2;
  }

  .network-icon-wrapper {
    position: absolute;
    ${flexCenter}
    top: 0.5rem;
    left: 0.5rem;
    ${circle(rem(30))}
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 3;
  }
`;

export const StyledVideoCallControls = styled.div`
  position: absolute;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  ${flexCenter}
  gap: 0.5rem;
  border-radius: var(--border-radius-3);
  z-index: 3;

  &.is-maximized {
    gap: 0.75rem;
    bottom: 1.5rem;

    // Need to repeat this style because the maximized component is in a portal
    button:not(.end-call-btn) {
      background-color: rgba(0, 0, 0, 0.35);
    }
  }

  button:not(.end-call-btn) {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;
